import { IconButton } from "@carbon6/c6-frontend-design";
import { ResourceBrowserLayout, PaginationFooter } from "@/components/browse";
import { FilterResultCount } from "@/components/filter";
import { workerJobStatusLabel } from "./workerJobStatusLabel";
import { WorkerJobDetailModal } from "./WorkerJobDetailModal";
import { WorkUnitProgressCell } from "./WorkUnitProgressCell";
import { WorkerQueueGuide } from "./WorkerQueueGuide";
import { useUploadJobsController } from "./useWorkerOperationsController";
import { WorkerTimeline } from "./WorkerTimeline";
import { jobTimeline } from "./workerTimelineModel";
import { tableStripError } from "@/components/table/tableStateMessages";

export function UploadJobsPanel() {
  const { source, snapshot, selected, setSelected, now, queryKey } = useUploadJobsController();
  const loading = snapshot.loadState === "loading";
  return (
    <>
      <ResourceBrowserLayout
        ariaLabel="관리자 업로드 큐"
        summaryCount={snapshot.total}
        summaryLabel="업로드 작업"
        summaryInFilter
        // 행이 없는 조회 실패는 타임라인 본문이 알린다. 띠에는 행이 남아 있는 실패만 올린다.
        error={tableStripError(snapshot)}
        onRetry={() => void source.refresh()}
        footer={
          <PaginationFooter
            page={snapshot.page}
            size={snapshot.size}
            total={snapshot.total}
            isLoading={loading}
            ariaLabel="업로드 큐 페이지 이동"
            onPrevious={() => snapshot.setPage(snapshot.page - 1)}
            onNext={() => snapshot.setPage(snapshot.page + 1)}
          />
        }
      >
        <WorkerTimeline
          ariaLabel="업로드 큐 타임라인"
          now={now}
          rangeKey={queryKey}
          loadState={snapshot.loadState}
          errorMessage={snapshot.errorMessage}
          onRetry={() => void source.refresh()}
          emptyMessage="조건에 맞는 업로드 작업이 없습니다."
          summary={<FilterResultCount count={snapshot.total} unitLabel="업로드 작업" />}
          actions={
            <>
              <WorkerQueueGuide kind="upload" />
              <IconButton
                text="새로고침"
                size="sm"
                variant="surface"
                disabled={loading}
                onClick={() => void source.refresh()}
              />
            </>
          }
          rows={snapshot.rows.map(({ job }) => ({
            id: job.uuid,
            name: job.display_name,
            status: workerJobStatusLabel(job.status),
            summary: (
              <WorkUnitProgressCell
                primary={
                  job.import_episode_count === null
                    ? "규모 확인 중"
                    : `복사 ${job.copy_cursor} · 확정 ${job.commit_cursor} / ${job.import_episode_count}`
                }
                units={job.units}
              />
            ),
            timeline: jobTimeline(job, now),
            onOpen: () => setSelected(job.uuid),
          }))}
        />
      </ResourceBrowserLayout>
      {selected !== null && (
        <WorkerJobDetailModal
          key={selected}
          kind="upload"
          uuid={selected}
          onClose={() => setSelected(null)}
          onChanged={() => source.refresh()}
        />
      )}
    </>
  );
}
